<template>
  <div>
    <b-modal id="video-modal" ref="video-modal-ref" hide-footer :title="title">
      <video-stream :options="videoOptions" />
      <b-button class="mt-3" block @click="hide()">
        Close
      </b-button>
    </b-modal>

  </div>
</template>

<script>
import VideoStream from "./video.vue";

export default {
  components: {
    VideoStream,
  },
  name: 'VideoPlayer',
  props: ['title', 'poster', 'src'],
  data() {
    return {
      videoOptions: {
        autoplay: false,
        controls: true,
        poster: this.poster,
        sources: [
          {
            src: this.src,
            type: 'application/x-mpegURL'
          }
        ]
      }
    }
  },
  methods: {
    showModal() {
      this.$refs["video-modal-ref"].show();
    },
    hide() {
      this.$refs["video-modal-ref"].hide();
    },
    setVideoSrc(_options) {
      this.videoOptions = _options;
    }
  },
};
</script>
